// Eerst jQuery op window zetten, daarna pas libs die global jQuery verwachten
import './jquery-global.js';
import $ from 'jquery';

// Bootstrap 4
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';

// Slick
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';

// AOS (Animate On Scroll)
import AOS from 'aos';
import 'aos/dist/aos.css';

// Lenis smooth scroll
import Lenis from 'lenis';

// Theme SCSS
import './style.scss';

(function ($) {

    $(function () {
 
        'use strict';

        // Lenis smooth scroll
        const lenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true
        });
        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);
        window.addEventListener('load', () => lenis.resize());
        window.addEventListener('resize', () => lenis.resize());

        // AOS – animate on scroll (data-aos="fade-up" etc.)
        AOS.init({
            duration: 600,
            offset: 200,
            once: true,
            anchorPlacement: 'top-bottom'
        });
        window.addEventListener('load', AOS.refresh);
        // Lenis scrollt niet via window – AOS moet bij elke scroll opnieuw kijken
        lenis.on('scroll', () => AOS.refresh());

        // MOBILE TOGGLE
        $('.menu-toggle').on('click', function () {
            if ($('.mobile-menu').hasClass('active')) {
                $('.mobile-menu, .page-overlay').removeClass('active');
                $('body').removeClass('noscroll');
            }
            else {
                $('.mobile-menu, .page-overlay').addClass('active');
                $('body').addClass('noscroll');
            }
        });
        $('.page-overlay').on('click', function () {
            $('.mobile-menu, .page-overlay').removeClass('active');
            $('body').removeClass('noscroll');
        });

        $('.mobile-menu ul li a, .header .logo').on('click', function() {
            $('body').removeClass('noscroll');
        });

        $( '<div class="subarrow"></div>' ).insertAfter('.mobile-menu li.menu-item-has-children > a');
        $('.mobile-menu .subarrow').on('click', function () {
            if ($(this).parent().hasClass('active')) {
                $(this).parent().removeClass('active');
            } else {
                $(this).parent().addClass('active');
            }
        });

        // HEADER SCROLLED
        $(window).scroll(function () {
            var scroll = $(window).scrollTop();
            if (scroll >= 1) {
                $(".header").addClass("scrolled");
            } else {
                $(".header").removeClass("scrolled");
            }
        });

        // HEADER BODY TO TOP (fixed header – body padding = header height)
        var headerTopBody = function () {
            var $header = $('header.header');
            if (!$header.length) return;
            var height = $header.outerHeight();
            if (typeof height === 'number' && height >= 0) {
                $('body').css('padding-top', height + 'px');
            }
        }; 

        headerTopBody();
        // Opnieuw na laden van afbeeldingen/fonts (logo in header)
        $(window).on('load', headerTopBody);

        var resizeTimeout;
        $(window).on('resize', function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(headerTopBody, 50);
        });

        // SLIDERS
        $('.homepage-header-slider').slick({
            fade: true,
            arrows: false,
            dots: false,
            autoplay: true,
            asNavFor: '.homepage-content-slider'
        });

        $('.logo-slider-wrap').slick({
            arrows: false,
            dots: false,
            autoplay: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnFocus: false,
            pauseOnHover: false,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 2,
                    }
                }, {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 2,
                    }
                },

                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 468,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                }
            ]
        });

        // Gallery block (homepage + over ons)
        if ( $('.gallery-block__slider').length && $('.gallery-block__slider').children().length ) {
            $('.gallery-block__slider').slick({
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                centerMode: true,
                centerPadding: '15px',
                autoplay: true,
                autoplaySpeed: 5500,
                speed: 800,
                responsive: [
                    { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1, centerMode: true, centerPadding: '20px' } },
                    { breakpoint: 992, settings: { slidesToShow: 4, slidesToScroll: 1, centerMode: true, centerPadding: '40px' } }
                ]
            });
        }

        // Product detail: main image + thumbnail navigation
        if ( $('.product-gallery__main').length ) {
            $('.product-gallery__main').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                adaptiveHeight: true,
                asNavFor: '.product-gallery__thumbs'
            });
            $('.product-gallery__thumbs').slick({ 
                slidesToShow: 5,
                slidesToScroll: 1,
                asNavFor: '.product-gallery__main',
                dots: false,
                arrows: false,
                focusOnSelect: true,
                centerMode: false,
                responsive: [
                    { breakpoint: 768, settings: { slidesToShow: 4 } },
                    { breakpoint: 576, settings: { slidesToShow: 3 } }
                ]
            });
        }

    });

})(jQuery);
